interface Props {
  originalPrice: { price: string | null } | null;
  currentPrice: { price: string | null } | null;
}

export const isDiscounted = (prices: Props): boolean => {
  if (!prices.originalPrice || !prices.currentPrice) {
    return true;
  }
  return (
    parseFloat(prices.currentPrice.price as string) <
    parseFloat(prices.originalPrice.price as string)
  );
};
